import { type FC, type ReactNode } from "react";

import styled from "@emotion/styled";
import { Skeleton } from "@snapchat/snap-design-system";
import { type BaseComponentProps } from "@snapchat/snap-design-system/es/shared/types";

interface SkeletonContainerProps extends BaseComponentProps {
    loading: boolean;
    width?: string;
    height?: number;
    paragraph?: number;
    children?: ReactNode;
}

/**
 * Renders Skeleton when loading prop is true or children otherwise.
 */
export const SkeletonContainer: FC<SkeletonContainerProps> = ({ loading, children, width, ...rest }) => {
    if (loading) {
        if (width == undefined) {
            return <Skeleton {...rest} />;
        }

        return (
            <SkeletonWrapper width={width}>
                <Skeleton {...rest} />
            </SkeletonWrapper>
        );
    }

    return <>{children}</>;
};

const SkeletonWrapper = styled.div<{ width?: string }>(({ width }) => ({
    width,
}));
